import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import * as R from 'ramda';

import { Container } from 'components/shared/container/Container.styled';
import { translate } from 'shared/utils/translate';
import { H3, H4, H5, H6, ParagraphRegular } from 'components/shared/typography';
import { CardProps, TextUnderImageProps } from './TextUnderImage.props';
import * as Styled from './TextUnderImage.styled';

const getSize = (count: number): string => {
  if (count < 2) return 'xlg';
  if (count <= 2) return 'lg';
  if (count === 3) return 'md';
  if (count === 4) return 'sm';
  return 'sm';
};

const getHeading = (size: string, img: boolean) => {
  const headings = img
    ? { xlg: H4, lg: H4, md: H5, sm: H6 }
    : { xlg: H3, lg: H3, md: H4, sm: H5 };
  return headings[size];
};

const Card = ({ size = 'lg', title, body, image, theme }: CardProps) => {
  const color = R.pathOr(null, ['color'], theme);

  const HeadingComponent = getHeading(size, !!image);
  const url = image || '';

  return (
    <Styled.CardWrapper size={size}>
      {image && <Styled.CardImage size={size} url={url} />}
      {title && (
        <Styled.HeadingWrapper size={size} isPlainText={!image}>
          <HeadingComponent color={color}>{title}</HeadingComponent>
        </Styled.HeadingWrapper>
      )}
      {body && (
        <Styled.SubHeadingWrapper>
          <ParagraphRegular color={color}>{body}</ParagraphRegular>
        </Styled.SubHeadingWrapper>
      )}
    </Styled.CardWrapper>
  );
};

const TextUnderImage = ({
  components,
  theme = {},
  intl,
}: WrappedComponentProps & TextUnderImageProps) => {
  if (!components) return null;

  const size = getSize(components.length);

  return (
    <Container size="md">
      <Styled.FlexibleLayout>
        {components.map(component => (
          <Card
            key={component.id}
            title={translate({ intl, id: component.title })}
            body={translate({ intl, id: component.body })}
            image={component.imageUrl || ''}
            size={size}
            theme={theme}
          />
        ))}
      </Styled.FlexibleLayout>
    </Container>
  );
};

export default injectIntl(TextUnderImage);
